var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7137",
    "data-name": "Group 7137",
    transform: "translate(-93 -198)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(93 198)",
    fill: "#00857c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MessageSent",
    transform: "translate(96.121 201.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1828",
    "data-name": "Rectangle 1828",
    width: 14,
    height: 14,
    transform: "translate(-0.121 -0.121)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_36",
    "data-name": "Union 36",
    d: "M2.544,6.455l-.019-.021L.1,4.01A.346.346,0,0,1,.59,3.522l2.2,2.2L8.41.1A.346.346,0,0,1,8.9.59L3.033,6.455a.345.345,0,0,1-.489,0Z",
    transform: "translate(2.042 3.787)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSelected);
export default __webpack_public_path__ + "static/media/CheckCircleSelected.629db0703da13adb9f5581bb1f228d75.svg";
export { ForwardRef as ReactComponent };